import t from "./ghl-ui.es1304.js";
import m from "./ghl-ui.es1305.js";
var a = m(function(e, r, o) {
  t(e, r, o);
});
const g = a;
export {
  g as default
};
